import { render, staticRenderFns } from "./yibanli.vue?vue&type=template&id=5e3bde09&scoped=true&"
import script from "./yibanli.vue?vue&type=script&lang=js&"
export * from "./yibanli.vue?vue&type=script&lang=js&"
import style0 from "./yibanli.vue?vue&type=style&index=0&id=5e3bde09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3bde09",
  null
  
)

export default component.exports